import React, { forwardRef } from 'react';
import { cx } from '../utils';
import './Skeleton.css';

const RADIUS = {
  sm: 'var(--radius-sm)',
  md: 'var(--radius-md)',
  lg: 'var(--radius-lg)',
  xl: 'var(--radius-xl)',
  full: 'var(--radius-full)',
};

const toCss = (value) => (typeof value === 'number' ? `${value}px` : value);

// width/height: raqam (px) yoki CSS qiymat; radius: sm | md | lg | xl | full yoki CSS qiymat
const Skeleton = forwardRef(function Skeleton(
  { width, height, radius, className, style, ...rest },
  ref
) {
  return (
    <span
      {...rest}
      ref={ref}
      aria-hidden="true"
      className={cx('ui-skeleton', className)}
      style={{
        width: toCss(width),
        height: toCss(height),
        borderRadius: radius ? RADIUS[radius] || toCss(radius) : undefined,
        ...style,
      }}
    />
  );
});

export default Skeleton;
